export const Constants = {
  CARD_DEFAULT_TIMELEFT: {
    minutes: 5,
    seconds: 0,
  },
  LIST_COLOR: '#EBECF0',
  DONELIST_COLOR: '#1565C0',
} 